export const UserCategory = {
  COMPANY: 'COMPANY',
  PRIVATE_PERSON: 'PRIVATE_PERSON',
  PERSONAL_BUSINESS: 'PERSONAL_BUSINESS',
} as const;
export type UserCategory = (typeof UserCategory)[keyof typeof UserCategory];
